import React from 'react';
import ContactForm from '../components/forms/ContactForm';
import Layout from '../layouts/MainLayout';

export default function Form() {
  return (
    <Layout>
      <ContactForm />
    </Layout>
  );
}